<template>
  <div class="flex flex-col items-center justify-center p-8">
    <span
      class="text-lg leading-loose mb-8 text-grey-800 text-center"
      v-html="$t('frontend_upgrade_message')"
    ></span>
    <div class="flex flex-col items-center justify-center">
      <a
        @click="goToUpgradePage"
        class="
          flex
          items-center
          cursor-pointer
          px-6
          py-3
          heading-sm
          focus:outline-none
          shadow
          hover:shadow-lg
          focus:shadow-lg
          rounded-lg
          bg-green-extra-dark
          text-white
          border-green-extra-dark border border-solid
          text-lg
        "
      >
        {{ $t('frontend_groovemember_members_for_see_all_awesomeupgrades') }}
      </a>
      <button class="mb-10 mt-6" @click="closeUpgradeModal()">
        {{ $t('frontend_groovemember_members_no_thanks') }}
      </button>
    </div>
  </div>
</template>

<script>
import auth from '@groovepages/gd-lib/auth';

export default {
  name: 'upgradeContent',

  methods: {
    goToUpgradePage() {
      let user = auth.authenticatedUser();
      let url = window.gdEnv[`UPGRADE_URL_${user?.metadata?.region?.toUpperCase()}`] || window.gdEnv[`UPGRADE_URL`];
      window.open(url, '_blank');
    },

    closeUpgradeModal() {
      this.$emit('closeUpgradeModal');
    },
  },
};
</script>
